import React, { useEffect, useState } from 'react'
import {
    autoUpdate,
    FloatingPortal,
    offset,
    useDismiss,
    useFloating,
    useFocus,
    useHover,
    useInteractions
} from '@floating-ui/react'

interface IProps {
    className?: string
    label: string
    enabled: boolean
    children: React.ReactNode
}

/** 레일(접힌 메뉴)에서 마우스를 올리거나 키보드로 갔을 때 오른쪽에 이름을 보인다 */
const RailTooltip: React.FC<IProps> = ({ className, label, enabled, children }) => {
    const [isOpen, setIsOpen] = useState(false)
    const { refs, floatingStyles, context } = useFloating({
        open: enabled && isOpen,
        onOpenChange: setIsOpen,
        placement: 'right',
        middleware: [offset(20)],
        whileElementsMounted: autoUpdate
    })
    const { getReferenceProps, getFloatingProps } = useInteractions([
        useHover(context, { enabled, delay: { open: 100 } }),
        useFocus(context, { enabled }),
        useDismiss(context, { enabled })
    ])

    useEffect(() => {
        setIsOpen(false)
    }, [enabled])

    return (
        <>
            <div ref={refs.setReference} className={className} {...getReferenceProps()}>
                {children}
            </div>
            {enabled && isOpen && (
                <FloatingPortal>
                    <div
                        ref={refs.setFloating}
                        style={floatingStyles}
                        aria-hidden
                        className={'app-rail-tooltip z-tooltip'}
                        {...getFloatingProps()}
                    >
                        <span>{label}</span>
                    </div>
                </FloatingPortal>
            )}
        </>
    )
}

export default RailTooltip
